import {AxiosError, AxiosRequestConfig} from 'axios';
import {ReceiptExpirationDateErrorAdditionalInfo} from '../types/receipt';

export interface RestError extends Error {
  additionalInfo?: ReceiptExpirationDateErrorAdditionalInfo;
  code?: string;
  status?: number;
  error?: string;
  config: AxiosRequestConfig;
}

export async function restError(err: AxiosError): Promise<RestError> {
  if (!err.response) {
    return err;
  }

  const {status, data, config} = err.response;
  const body = (data && typeof data === 'object' ? data : {}) as {
    message?: string;
    code?: string | null;
    additionalInfo?: ReceiptExpirationDateErrorAdditionalInfo;
    errors?: Array<{code?: string | null; message?: string}>;
  };
  const firstError = Array.isArray(body.errors) ? body.errors[0] : undefined;
  const message = body.message || firstError?.message || '';
  const code = body.code || firstError?.code || undefined;
  const {additionalInfo} = body;

  return {
    ...(new Error(message) as RestError),
    message,
    name: 'RestError',
    status,
    code,
    config,
    additionalInfo,
  };
}
